import React from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

const Navbar: React.FC = () => {
  return (
    <nav className="navbar">
      <ul className="navbar-list">
        <li className="navbar-item">
          <NavLink
            className={({ isActive }) =>
              "navbar-link" + (isActive ? " active" : "")
            }
            to="/roas-pno"
          >
            ROAS-PNO Kalkulačka
          </NavLink>
        </li>
        <li className="navbar-item">
          <NavLink
            className={({ isActive }) =>
              "navbar-link" + (isActive ? " active" : "")
            }
            to="/feed-analysis"
          >
            Analýza XML feedů
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
